module.exports = __webpack_public_path__ + "img/1000T.0449c690.jpg";